import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Pagination, Row,ConfigProvider } from 'antd';
import { Delete_CustomType_Api, GetAll_Paging_CustomType_Api } from '../../API/CustomTypeApi';
import { CloseOutlined, DeleteOutlined, DoubleRightOutlined, EditOutlined, PlusOutlined, RollbackOutlined } from '@ant-design/icons';
import faIR from 'antd/locale/fa_IR';
// ======================================================================
export const AllCustomTypeComponent = ({
    setLoading,
    showMessage,
    parentId,
    parentTitle,
    version,
    currentPage,
    setCurrentPage,
    onAddClick,
    onEdit,
    onBackClick,
    onDetailsClick,
    onRowDeleted }) => {
    // ======================================================================
    const [customTypes, setCustomTypes] = useState([]);
    const [pageCount, setPageCount] = useState(4);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, [currentPage, version]);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Paging_CustomType_Api({ pageNumber: currentPage, parentId: parentId });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setPageCount(data.messageData.pageCount * 10)
                setCustomTypes(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const deleteRow = async (id) => {
        try {
            setLoading(true);
            let data = await Delete_CustomType_Api(id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                onRowDeleted();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    return (
        <>
            <Row className='sectionTitle'>
                <>
                    <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                        {parentId != 0 ?
                            <Button onClick={() => onBackClick()}>
                                <DoubleRightOutlined />
                                بازگشت
                            </Button> : <></>}
                    </Col>
                    <Col xs={10} sm={10} md={10} lg={14} xl={14}>
                        <h2 >
                            {parentId == 0 ? "لیست ها" : "مقادیر " + parentTitle}

                        </h2>
                    </Col>
                    <Col xs={10} sm={10} md={8} lg={6} xl={6} style={{ textAlign: "left" }}>
                        <Button className='btn-primary'
                            onClick={() => onAddClick()} >
                            <PlusOutlined />
                            ایجاد رکورد جدید
                        </Button>
                    </Col>
                </>

            </Row>
            <div className='container'>
                {customTypes.map((customType, key) =>
                    <>
                        <Row key={key} className="valueRow" >
                            <Col className="valueColumn textRight clickable" xs={12} sm={12} md={12} lg={15} xl={15} onClick={() => onDetailsClick(customType.id, customType.title)} >
                                {customType.title}
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={9} xl={9} style={{ textAlign: "left" }}>

                                <Button className='btn-success' style={{ marginLeft: "2px" }} onClick={() => onEdit(customType.id)}>
                                    <EditOutlined />
                                    ویرایش</Button>

                                <Button
                                    className='btn-danger'
                                    onClick={() => {
                                        Modal.confirm({
                                            title: 'آیا از حذف ' + customType.title + ' اطمینان دارید؟',
                                            onOk: () => { deleteRow(customType.id) },
                                            footer: (_, { OkBtn, CancelBtn }) => (
                                                <>
                                                    <CancelBtn />
                                                    <OkBtn />
                                                </>
                                            ),
                                        });
                                    }}
                                >
                                    <DeleteOutlined />
                                    حذف</Button>
                            </Col>
                        </Row>
                    </>
                )}
            </div>
            <ConfigProvider direction="rtl" locale={faIR}>
            <Pagination current={currentPage}  showSizeChanger={false} 
                            showQuickJumper={false}  align="center" onChange={(page) => setCurrentPage(page)} total={pageCount} />
        </ConfigProvider>
        </>

    )
}